<template>
  <v-navigation-drawer
    v-model="model"
    location="end"
    temporary
    :width="drawerWidth"
  >
    <!-- Resize Handle -->
    <span class="drawer-resizer" @mousedown="startResize"></span>
    <v-toolbar flat class="bg-primary drawer-header">
      <v-toolbar-title class="section-title">{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="model = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="drawer-body">
      <slot />
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "RbNavigationDrawer",

  props: {
    modelValue: Boolean,

    width: {
      type: [String, Number],
      default: 350,
    },

    title: {
      type: String,
      default: "Drawer",
    },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      drawerWidth: this.width,
      isResizing: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  methods: {
    startResize() {
      this.isResizing = true;

      document.addEventListener("mousemove", this.resizeDrawer);
      document.addEventListener("mouseup", this.stopResize);
    },

    resizeDrawer(e) {
      if (!this.isResizing) return;

      const newWidth = window.innerWidth - e.clientX;

      if (newWidth > 300 && newWidth < 900) {
        this.drawerWidth = newWidth;
      }
    },

    stopResize() {
      this.isResizing = false;

      document.removeEventListener("mousemove", this.resizeDrawer);
      document.removeEventListener("mouseup", this.stopResize);
    },
  },
};
</script>
<style scoped>
.drawer-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.drawer-body {
  height: calc(100% - 64px);
  overflow-y: auto;
}

.drawer-resizer {
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  background: transparent;
  z-index: 3;
}

/* .drawer-resizer:hover {
  background: rgba(0, 0, 0, 0.1);
} */
</style>
